import React, { useState, useEffect } from "react";

import {
  GoogleMap,
  Polyline,
  useJsApiLoader,
  InfoWindow,
  Marker,
  Circle,
  OverlayView,
} from "@react-google-maps/api";
import UserWithLabel from "./UserWithLabel";

import config from "../../config/config";
import moment from "moment";
import { json } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import locationIcon from "../../img/red dot icon.svg";
import employeeIcon from "../../img/employee.png";
import {
  Badge,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Typography,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { display } from "@mui/system";
import CircleIcon from "@mui/icons-material/Circle";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

const containerStyle = {
  width: "100%",
  minHeight: "400px",
  height: "79vh",
  borderRadius: "11px",
};
const dashboardMapStyles = {
  width: "100%",
  // minHeight: "400px",
  height: "100%",
  borderRadius: "11px",
};

let center = {
  lat: 28.6139,
  lng: 77.209,
};

const options = {
  strokeColor: "#0085B2",
  strokeOpacity: 0.8,
  strokeWeight: 8,
  fillColor: "#FF0000",
  fillOpacity: 0.35,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  radius: 30000,
  // paths: [
  //   { lat: 37.772, lng: -122.214 },
  //   { lat: 21.291, lng: -157.821 },
  //   { lat: -18.142, lng: 178.431 },
  //   { lat: -27.467, lng: 153.027 },
  // ],
  zIndex: 1,
};

const lostPathPolyLineOptions = {
  strokeColor: "#b10b05",
  strokeOpacity: 0.8,
  strokeWeight: 8,
  fillColor: "#FF0000",
  fillOpacity: 0.35,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  radius: 30000,
  // paths: [
  //   { lat: 37.772, lng: -122.214 },
  //   { lat: 21.291, lng: -157.821 },
  //   { lat: -18.142, lng: 178.431 },
  //   { lat: -27.467, lng: 153.027 },
  // ],
  zIndex: 1,
};

// const liveTrackingPolyLineOptions = {
//   strokeColor: "#f86a18",
//   strokeOpacity: 0.8,
//   strokeWeight: 8,
//   fillColor: "#FF0000",
//   fillOpacity: 0.35,
//   clickable: false,
//   draggable: false,
//   editable: false,
//   visible: true,
//   radius: 30000,
//   // paths: [
//   //   { lat: 37.772, lng: -122.214 },
//   //   { lat: 21.291, lng: -157.821 },
//   //   { lat: -18.142, lng: 178.431 },
//   //   { lat: -27.467, lng: 153.027 },
//   // ],
//   zIndex: 1,
// };

const liveTrackingPolyLineOptions = {
  strokeColor: "#f86a18",
  strokeOpacity: 0, // hide the solid line
  strokeWeight: 8,
  fillColor: "#FF0000",
  fillOpacity: 0.35,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  radius: 30000,
  zIndex: 2,
  icons: [
    {
      icon: {
        path: "M 0,-1 0,1", // small vertical line
        strokeOpacity: 1,
        strokeWeight: 5,
        scale: 4, // thickness of dash
      },
      offset: "0",
      repeat: "20px", // distance between dashes
    },
  ],
};

const paths = [
  { lat: 37.772, lng: -122.214 },
  { lat: 21.291, lng: -157.821 },
  { lat: -18.142, lng: 178.431 },
  { lat: -27.467, lng: 153.027 },
];

const divStyleStart = {
  background: "linear-gradient(135deg, #0f9d58 0%, #2bb673 100%)",
  padding: "10px 12px",
  color: "#fff",
  textAlign: "left",
  borderRadius: "14px",
  boxShadow: "0 10px 24px rgba(15, 157, 88, 0.25)",
};

const divStyleEnd = {
  background: "linear-gradient(135deg, #d9485f 0%, #f25f5c 100%)",
  padding: "10px 12px",
  color: "#fff",
  textAlign: "left",
  borderRadius: "14px",
  boxShadow: "0 10px 24px rgba(217, 72, 95, 0.25)",
};

const divStyleClient = {
  background: "linear-gradient(135deg, #1d5cf5 0%, #3f8cff 100%)",
  padding: "10px 12px",
  color: "#fff",
  textAlign: "left",
  borderRadius: "14px",
  boxShadow: "0 10px 24px rgba(29, 92, 245, 0.25)",
};
let gggg = new Date(
  new Date().getTime("12:45:45") + 4 * 60 * 60 * 1000,
).toLocaleTimeString();
console.log(gggg, "gggg");
// const ddd=json.parse("01:20:41")
// let startTimeData=moment(ddd).format("hh:mm: A")
// console.log(startTimeData,"startTimeData")
// const[start,setSatart]=useState(moment("12:45").format("hh:mm: A"))

const colorMap = {
  Red: "#FF0000",
  Blue: "#0000FF",
  Green: "#00FF00",
  Yellow: "#FFFF00",
  Gray: "#808080",
};

const getOverlayStyles = (colorName) => {
  const bgColor = colorMap[colorName] || "#000000";

  const hex = bgColor.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Improved brightness calculation
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // Lowered threshold → Green now gets white text (better contrast)
  const textColor = brightness > 135 ? "#000" : "#fff";

  return {
    bgColor,
    textColor,
  };
};

const MapComponent = ({
  userInfoTotal,
  bound,
  isDashboard,
  isDetails,
  details,
  userInfo,
  userListData,
  dashboardMapStyle,
  isAutoDefaultMeetingEnabled,
  isLiveTrackingOn = false,
  liveTrackingPolyPath = [],
  isLiveTrackCheckBoxToShow = false,
  isLiveTrackingToShowChecked = false,
  isPreviousPathCheckBoxToShow = false,
  isPreviousPathToShowChecked = true,
  userWiseGeofences = [],
  hasGeofencePermission = false,
  geofenceToShow = false,
  handleToggleGeofenceToShow = () => {},
  handleChangeIsLiveTrackingToShowChecked = () => {},
  handleChangeIsPreviousPathToShowChecked = () => {},
  handleOpenGeofenceSessionsModal = () => {},

  isShowLostPath,
  setIsShowLostPath,
  distanceDetail,
  isEnableShowActualPath = false,
}) => {
  console.log(details, "91");
  const [showInfoWindow, setShowInfoWindow] = useState(true);
  const [stopLocationInfho, setStopLocationInfho] = useState(true);
  const [closedStopLocationWindows, setClosedStopLocationWindows] = useState(
    {},
  );
  const [closedClientInfoWindows, setClosedClientInfoWindows] = useState({});
  const [showUser, setShowUser] = useState(false);

  const [userData, setUserData] = useState([]);
  const [deatalsData, setDetailsdata] = useState([]);

  const [hiddenLabels, setHiddenLabels] = useState({});

  console.log(showUser, "rerendered");

  const uniqueDetailsStartPoints = new Set();
  details?.forEach((item) => {
    if (item?.startLatLong) {
      uniqueDetailsStartPoints.add(
        [item?.startLatLong, item?.createdDate]?.join(","),
      );
    }
  });
  const uniqueDetailsEndPoints = new Set();
  details?.forEach((item) => {
    if (item?.endLatLong) {
      uniqueDetailsEndPoints.add([item?.endLatLong, item?.date]?.join(","));
    }
  });
  // const [showHideInfoWindowLatLong, setShowHideInfoWindowLatLong] =
  //   useState(null);

  // const handleShowHideInfoWindow = (lat, lng, type, client, currCliIndex) => {
  //   const obj = {
  //     lat,
  //     lng,
  //     type,
  //     client,
  //     currCliIndex,
  //   };
  //   const objToSet = { ...obj };
  //   // alert(JSON.stringify(objToSet));
  //   setShowHideInfoWindowLatLong(objToSet);
  // };
  // console.log(showHideInfoWindowLatLong, "watchh");
  const openStopLocation = (id) => {
    setClosedStopLocationWindows((closedWindows) => ({
      ...closedWindows,
      [id]: false,
    }));
    setStopLocationInfho(true);
  };

  const CloseStopLocation = (id) => {
    setClosedStopLocationWindows((closedWindows) => ({
      ...closedWindows,
      [id]: true,
    }));
  };

  const handleShowUserChange = (checked) => {
    setShowUser(checked);

    if (!checked) {
      setStopLocationInfho(false);
      return;
    }

    setClosedStopLocationWindows({});
    setStopLocationInfho(true);
  };

  console.log(details, "detaaaails");
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    // googleMapsApiKey: "AIzaSyDeYU6TMPh3iavQ_v7DCGyJQpQW_yoJCZg",
    googleMapsApiKey: config.apiKey,
  });
  //   var upd = setInterval(function(){
  //     window.dispatchEvent(new Event('resize'));
  //     // clearInterval(upd)
  // }, 500)
  const [map, setMap] = useState(null);

  const onLoad = React.useCallback(function callback(map) {
    //alert("jj")

    // WARNING !!!!
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    // const bounds = new window.google.maps.LatLngBounds(center);
    // map.fitBounds(bounds);

    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const handleSetBound = () => {
    if (bound && map) {
      const bounds = new window.google.maps.LatLngBounds(bound);
      map.fitBounds(bounds);
      console.log(bounds, "boundsgdfyugf");
    }
  };

  console.log(details);

  const handleSetDetails = (details) => {
    if (isDetails && details.length !== 0 && map) {
      console.log(details, "1254");
      // const bounds = new window.google.maps.LatLngBounds({
      //   lat: parseFloat(details[0].endLatLong.split(",")[0].trim()),
      //   lng: parseFloat(details[0].endLatLong.split(",")[1].trim()),
      // });
      const bounds = new window.google.maps.LatLngBounds();
      details &&
        Boolean(details.length) > 0 &&
        details.forEach((detail) => {
          console.log(detail, "detailydy");
          if (detail.routeResponse && Boolean(detail.routeResponse.length)) {
            JSON.parse(detail.routeResponse).forEach((item) => {
              item.midPointArray.forEach((val) => {
                bounds.extend(val);
              });
            });
          }
        });
      map.fitBounds(bounds);
      console.log(bounds, "boundsgdfyugf");
    }
  };

  const handleSetDetailsForLiveTracking = (liveTrackingPaths) => {
    if (
      isDetails &&
      isLiveTrackingOn &&
      liveTrackingPaths.length !== 0 &&
      map
    ) {
      console.log(liveTrackingPaths, "1254");

      const bounds = new window.google.maps.LatLngBounds();
      liveTrackingPaths &&
        Boolean(liveTrackingPaths.length) > 0 &&
        liveTrackingPaths.forEach((pathCord) => {
          console.log(pathCord, "detailydy");
          bounds.extend(pathCord);
        });
      map.fitBounds(bounds);
      console.log(bounds, "boundsgdfyugf");
    }
  };

  const onLoadInfo = (infoWindow) => {
    console.log(infoWindow, "infoWindow");
  };

  const handleChangeIsLiveTrackingToShowCheckedOnCheck = (value) => {
    handleChangeIsLiveTrackingToShowChecked(value);
  };
  const handleChangeIsPreviousPathToShowCheckedOnCheck = (value) => {
    handleChangeIsPreviousPathToShowChecked(value);
  };
  useEffect(() => {
    handleSetBound();
  }, [bound]);
  useEffect(() => {
    handleSetDetails(details);
  }, [details, map]);

  useEffect(() => {
    if (isLiveTrackingOn) {
      handleSetDetailsForLiveTracking(liveTrackingPolyPath);
    }
  }, [liveTrackingPolyPath, map, isLiveTrackingOn]);
  // useEffect(()=>{
  //   handleSetDetails()
  // },[map])
  // useEffect(()=>{
  //   //handleSetDetails()
  //  /// onLoad()
  //  const id = setInterval(() => {
  //   alert("jj")
  //   // console.log("settttttt");
  //   // if (search !== "") {
  //     handleSetDetails();
  //  // }

  //   // client_communicatindata();
  // }, 100);
  // return () => {
  //   clearInterval(id);
  // };
  // },[])

  // useEffect(()=>{

  //   // let sortDetails=details && details.clientCommunicationDtoList.reverse()
  //   // setDetailsdata(sortDetails)

  // },[details])

  const gpsLossCoordinates = [
    [
      [25.2344052, 86.9355653],
      [25.2344704, 86.9350487],
    ],
    [
      [25.2351001, 86.9360002],
      [25.2400001, 86.9400005],
    ],
  ];

  const mergeCalculatedRoute = (locationGapList, routeResponse) => {
    const routes =
      typeof routeResponse === "string"
        ? JSON.parse(routeResponse)
        : routeResponse;

    return locationGapList.map((gap, index) => {
      const calculatedPoints = routes[index]?.midPointArray ?? [];

      return [
        gap[0],
        ...calculatedPoints.map((point) => ({
          latitude: point.lat,
          longitude: point.lng,
          isCalculatedPoint: true,
        })),
        gap[1],
      ];
    });
  };

  console.log("uniqueDetailsStartPoints: ", { details, distanceDetail });
  console.log("uniqueDetailsEndPoints: ", Array.from(uniqueDetailsEndPoints));
  let currCommDetl = 1;

  const formatDate = (date) => moment(date).format("DD/MM/YY hh:mm A");

  const prepareLocationGapRoute = (locationGapList, calculatedRoutes) => {
    if (!Array.isArray(locationGapList) || !Array.isArray(calculatedRoutes)) {
      return [];
    }

    return locationGapList.map((gap, index) => {
      const route = calculatedRoutes[index];

      if (
        !route ||
        !route.midPointArray ||
        !Array.isArray(route.midPointArray)
      ) {
        return gap;
      }

      const start = gap[0];
      const end = gap[1];

      const middlePoints = route.midPointArray.map((point) => ({
        latitude: point.lat,
        longitude: point.lng,
        isCalculatedPoint: true,
      }));

      return [start, ...middlePoints, end];
    });
  };

  // Haversine formula to calculate distance between two lat/lng points
  function insertRouteIntermediatePoints(lostPathArray, googleApiResponseJson) {
    // Parse the Google API response
    const response = JSON.parse(googleApiResponseJson);
    // The provided JSON is an array with one element holding the route data
    const routeData = response[0];
    const midPoints = routeData.midPointArray; // array of {lng, lat}

    // Helper: distance in meters between two {lat, lng} points
    function distance(p1, p2) {
      const R = 6371000; // Earth radius in meters
      const lat1 = (p1.lat * Math.PI) / 180;
      const lat2 = (p2.lat * Math.PI) / 180;
      const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
      const dLng = ((p2.lng - p1.lng) * Math.PI) / 180;
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    const result = lostPathArray.map((segment) => {
      const startObj = segment[0];
      const endObj = segment[1];

      const startPt = { lat: startObj.latitude, lng: startObj.longitude };
      const endPt = { lat: endObj.latitude, lng: endObj.longitude };

      // Find the index of the polyline point closest to the end point.
      let endIdx = -1;
      let minDist = Infinity;
      for (let i = 0; i < midPoints.length; i++) {
        const d = distance(midPoints[i], endPt);
        if (d < minDist) {
          minDist = d;
          endIdx = i;
        }
      }

      // Find the index closest to the start point.
      let startIdx = -1;
      let startMinDist = Infinity;
      for (let i = 0; i < midPoints.length; i++) {
        const d = distance(midPoints[i], startPt);
        if (d < startMinDist) {
          startMinDist = d;
          startIdx = i;
        }
      }

      // If the start point is exactly on the polyline (≤1 m),
      // we skip that vertex to avoid duplicating the start location.
      const isStartExact = startMinDist < 1;
      const sliceStart = isStartExact ? startIdx + 1 : startIdx;

      // Safety: if the order is backwards, just return the two original points.
      if (sliceStart >= endIdx) {
        return [startObj, endObj];
      }

      // Extract the intermediate polyline points (exclude the end point)
      const intermediatePoints = midPoints
        .slice(sliceStart, endIdx)
        .map((p) => ({
          latitude: p.lat,
          longitude: p.lng,
        }));

      // Build the new segment: start → intermediates → end
      return [startObj, ...intermediatePoints, endObj];
    });

    return result;
  }

  // This is a more optimized version of the above function, using a Map for O(1) lookups and a nearest-neighbor search if no exact match is found. It also rounds coordinates to 6 decimal places to avoid floating-point issues.
  function insertRouteIntermediatePointsV4(
    lostPathArray,
    googleApiResponseJson,
  ) {
    // Parse the Google API response
    const response = JSON.parse(googleApiResponseJson);
    const routeData = response[0];
    const midPoints = routeData.midPointArray; // array of {lng, lat}

    // ---------- Helpers ----------
    const round = (num) => Math.round(num * 1e6) / 1e6;

    // Build a lookup: "lat,lng" → array of indices
    const lookup = new Map();
    midPoints.forEach((p, idx) => {
      const key = `${round(p.lat)},${round(p.lng)}`;
      if (!lookup.has(key)) lookup.set(key, []);
      lookup.get(key).push(idx);
    });

    // Fast nearest index if exact match fails (uses squared degree distance)
    function findNearestIndex(targetLat, targetLng) {
      let bestIdx = -1;
      let bestDistSq = Infinity;
      const tLat = round(targetLat);
      const tLng = round(targetLng);
      for (let i = 0; i < midPoints.length; i++) {
        const dLat = round(midPoints[i].lat) - tLat;
        const dLng = round(midPoints[i].lng) - tLng;
        const distSq = dLat * dLat + dLng * dLng;
        if (distSq < bestDistSq) {
          bestDistSq = distSq;
          bestIdx = i;
          if (distSq < 1e-12) break; // exact match after rounding
        }
      }
      return bestIdx;
    }

    function getClosestIndices(startPt, endPt) {
      // Try exact match first (O(1) lookup)
      const startKey = `${round(startPt.lat)},${round(startPt.lng)}`;
      const endKey = `${round(endPt.lat)},${round(endPt.lng)}`;
      let startIdx = lookup.has(startKey) ? lookup.get(startKey)[0] : -1;
      let endIdx = lookup.has(endKey) ? lookup.get(endKey)[0] : -1;

      // Fallback: nearest neighbour (only if exact match not found)
      if (startIdx === -1)
        startIdx = findNearestIndex(startPt.lat, startPt.lng);
      if (endIdx === -1) endIdx = findNearestIndex(endPt.lat, endPt.lng);

      return { startIdx, endIdx };
    }

    // ---------- Main logic ----------
    return lostPathArray?.map((segment) => {
      const startObj = segment[0];
      const endObj = segment[1];
      const startPt = { lat: startObj.latitude, lng: startObj.longitude };
      const endPt = { lat: endObj.latitude, lng: endObj.longitude };

      let { startIdx, endIdx } = getClosestIndices(startPt, endPt);

      // If the segment order appears reversed, flip indices
      if (startIdx > endIdx) {
        [startIdx, endIdx] = [endIdx, startIdx];
      }

      // Avoid duplicating the start point if it exactly matches a vertex
      const startIsExact =
        round(midPoints[startIdx]?.lat ?? 0) === round(startPt.lat) &&
        round(midPoints[startIdx]?.lng ?? 0) === round(startPt.lng);
      const sliceStart = startIsExact ? startIdx + 1 : startIdx;

      // Safety: if no intermediate points, return original pair
      if (sliceStart >= endIdx) {
        return [startObj, endObj];
      }

      // Extract the intermediate points (excluding the end vertex)
      const intermediatePoints = midPoints
        .slice(sliceStart, endIdx)
        .map((p) => ({ latitude: p.lat, longitude: p.lng }));

      // Return enriched segment: start → intermediates → end
      return [startObj, ...intermediatePoints, endObj];
    });
  }

  // This is a further optimized version that combines exact lookups and nearest-neighbor search, while also ensuring that the function is robust against edge cases. It uses a Map for O(1) lookups and a simple linear search for nearest neighbors if no exact match is found.
  function insertRouteIntermediatePointsV3(
    lostPathArray,
    googleApiResponseJson,
  ) {
    const response = JSON.parse(googleApiResponseJson);
    const routeData = response[0];
    const midPoints = routeData.midPointArray; // [{lng, lat}, ...]

    // ---------- Fast matching helpers ----------
    const round = (num) => Math.round(num * 1e6) / 1e6;

    // Map for exact lookups (O(1) average)
    const exactMap = new Map();
    midPoints.forEach((p, idx) => {
      const key = `${round(p.lat)},${round(p.lng)}`;
      if (!exactMap.has(key)) exactMap.set(key, idx);
    });

    // Fallback: find index of nearest vertex using simple squared differences
    function findNearestIndex(lat, lng) {
      let bestIdx = 0;
      let bestDistSq = Infinity;
      const rLat = round(lat);
      const rLng = round(lng);
      for (let i = 0; i < midPoints.length; i++) {
        const dLat = round(midPoints[i].lat) - rLat;
        const dLng = round(midPoints[i].lng) - rLng;
        const distSq = dLat * dLat + dLng * dLng;
        if (distSq < bestDistSq) {
          bestDistSq = distSq;
          bestIdx = i;
          if (distSq === 0) break; // exact match after rounding
        }
      }
      return bestIdx;
    }

    // Get index for a point: exact first, then nearest
    function getIndex(lat, lng) {
      const key = `${round(lat)},${round(lng)}`;
      if (exactMap.has(key)) return exactMap.get(key);
      return findNearestIndex(lat, lng);
    }

    // ---------- Main enrichment ----------
    return lostPathArray.map((segment) => {
      const startObj = segment[0];
      const endObj = segment[1];

      let startIdx = getIndex(startObj.latitude, startObj.longitude);
      let endIdx = getIndex(endObj.latitude, endObj.longitude);

      // Ensure forward order
      if (startIdx > endIdx) {
        [startIdx, endIdx] = [endIdx, startIdx];
      }

      // Avoid duplicating the exact start vertex
      const sliceStart = startIdx + 1;

      if (sliceStart >= endIdx) {
        return [startObj, endObj];
      }

      // Extract intermediate polyline vertices
      const intermediatePoints = midPoints
        .slice(sliceStart, endIdx)
        .map((p) => ({ latitude: p.lat, longitude: p.lng }));

      return [startObj, ...intermediatePoints, endObj];
    });
  }

  function insertRouteIntermediatePointsV2(
    lostPathArray,
    googleApiResponseJson,
    options = {},
  ) {
    const thresholdMeters = options.thresholdMeters ?? 100; // default 100 m

    const response = JSON.parse(googleApiResponseJson);
    const routeData = response[0];
    const midPoints = routeData.midPointArray; // array of {lng, lat}

    // ---------- Helpers ----------
    const round = (num) => Math.round(num * 1e6) / 1e6;

    // Distance in meters between two {lat, lng} objects
    function distanceMeters(p1, p2) {
      const R = 6371000;
      const lat1 = (p1.lat * Math.PI) / 180;
      const lat2 = (p2.lat * Math.PI) / 180;
      const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
      const dLng = ((p2.lng - p1.lng) * Math.PI) / 180;
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // Build a lookup: "lat,lng" → first index
    const lookup = new Map();
    midPoints.forEach((p, idx) => {
      const key = `${round(p.lat)},${round(p.lng)}`;
      if (!lookup.has(key)) lookup.set(key, idx); // keep only first occurrence
    });

    // Fast nearest index if exact match fails
    function findNearestIndex(targetLat, targetLng) {
      let bestIdx = -1;
      let bestDistSq = Infinity;
      const tLat = round(targetLat);
      const tLng = round(targetLng);
      for (let i = 0; i < midPoints.length; i++) {
        const dLat = round(midPoints[i].lat) - tLat;
        const dLng = round(midPoints[i].lng) - tLng;
        const distSq = dLat * dLat + dLng * dLng;
        if (distSq < bestDistSq) {
          bestDistSq = distSq;
          bestIdx = i;
          if (distSq < 1e-12) break; // exact match
        }
      }
      return bestIdx;
    }

    function getClosestIndex(lat, lng) {
      const key = `${round(lat)},${round(lng)}`;
      if (lookup.has(key)) return lookup.get(key);
      return findNearestIndex(lat, lng);
    }

    // ---------- Main logic ----------
    const enriched = lostPathArray?.map((segment) => {
      const startObj = segment[0];
      const endObj = segment[1];
      const startPt = { lat: startObj.latitude, lng: startObj.longitude };
      const endPt = { lat: endObj.latitude, lng: endObj.longitude };

      const startIdx = getClosestIndex(startPt.lat, startPt.lng);
      const endIdx = getClosestIndex(endPt.lat, endPt.lng);

      const matchedStart = {
        lat: midPoints[startIdx].lat,
        lng: midPoints[startIdx].lng,
      };
      const matchedEnd = {
        lat: midPoints[endIdx].lat,
        lng: midPoints[endIdx].lng,
      };

      // Check distance to matched vertices
      const distStart = distanceMeters(startPt, matchedStart);
      const distEnd = distanceMeters(endPt, matchedEnd);

      if (distStart > thresholdMeters || distEnd > thresholdMeters) {
        // Too far from the known route – skip this segment completely
        return null;
      }

      // Override original objects' coordinates with the exact road points
      const snappedStart = {
        ...startObj,
        latitude: matchedStart.lat,
        longitude: matchedStart.lng,
      };
      const snappedEnd = {
        ...endObj,
        latitude: matchedEnd.lat,
        longitude: matchedEnd.lng,
      };

      // Ensure forward direction
      let sIdx = startIdx,
        eIdx = endIdx;
      if (sIdx > eIdx) [sIdx, eIdx] = [eIdx, sIdx];

      // If start matches exactly, avoid duplicating that vertex
      const startIsExact =
        round(midPoints[sIdx].lat) === round(matchedStart.lat) &&
        round(midPoints[sIdx].lng) === round(matchedStart.lng);
      const sliceStart = startIsExact ? sIdx + 1 : sIdx;

      // Extract intermediate points (exclude end vertex)
      const intermediatePoints = midPoints
        .slice(sliceStart, eIdx)
        .map((p) => ({ latitude: p.lat, longitude: p.lng }));

      // Build enriched segment: snapped start → intermediates → snapped end
      return [snappedStart, ...intermediatePoints, snappedEnd];
    });

    // Remove null entries (segments that were too far away)
    return enriched.filter(Boolean);
  }

  function insertRouteIntermediatePointsV2x(
    lostPathArray,
    googleApiResponseJson,
    options = {},
  ) {
    // Max distance (meters) from a raw GPS point to the nearest road vertex
    const thresholdMeters = options.thresholdMeters ?? 100;

    const response = JSON.parse(googleApiResponseJson);
    const routeData = response[0];
    const midPoints = routeData.midPointArray; // [{lng, lat}, ...]

    // ---------- Helpers ----------
    const round = (num) => Math.round(num * 1e6) / 1e6;

    // Haversine distance in meters
    function distanceMeters(p1, p2) {
      const R = 6371000;
      const lat1 = (p1.lat * Math.PI) / 180;
      const lat2 = (p2.lat * Math.PI) / 180;
      const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
      const dLng = ((p2.lng - p1.lng) * Math.PI) / 180;
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    // ---------- Main logic ----------
    const enriched = lostPathArray?.map((segment) => {
      const startObj = segment[0];
      const endObj = segment[1];

      const rawStart = { lat: startObj.latitude, lng: startObj.longitude };
      const rawEnd = { lat: endObj.latitude, lng: endObj.longitude };

      // 1. Find ALL vertices within threshold for start & end
      const startCandidates = [];
      const endCandidates = [];

      midPoints.forEach((p, idx) => {
        const dStart = distanceMeters(p, rawStart);
        const dEnd = distanceMeters(p, rawEnd);

        if (dStart <= thresholdMeters) {
          startCandidates.push({ idx, dist: dStart });
        }
        if (dEnd <= thresholdMeters) {
          endCandidates.push({ idx, dist: dEnd });
        }
      });

      // 2. Need at least one candidate for both
      if (startCandidates.length === 0 || endCandidates.length === 0) {
        return null;
      }

      // 3. Find best valid pair: startIdx < endIdx AND at least one intermediate vertex
      let bestPair = null;

      for (const s of startCandidates) {
        for (const e of endCandidates) {
          // Must respect route direction and have at least 1 intermediate point
          if (s.idx >= e.idx) continue; // start must be before end
          if (e.idx - s.idx < 2) continue; // require at least one road vertex between them

          // Score = closeness of start + closeness of end + route length (shorter better)
          const score = s.dist + e.dist + (e.idx - s.idx);

          if (!bestPair || score < bestPair.score) {
            bestPair = {
              startIdx: s.idx,
              endIdx: e.idx,
              score,
            };
          }
        }
      }

      // 4. No valid pair -> drop segment entirely
      if (!bestPair) {
        return null;
      }

      const sIdx = bestPair.startIdx;
      const eIdx = bestPair.endIdx;

      // 5. Snap original coordinates to the exact road vertices
      const snappedStart = {
        ...startObj,
        latitude: midPoints[sIdx].lat,
        longitude: midPoints[sIdx].lng,
      };

      const snappedEnd = {
        ...endObj,
        latitude: midPoints[eIdx].lat,
        longitude: midPoints[eIdx].lng,
      };

      // 6. Extract intermediate road vertices (excluding start & end)
      const intermediatePoints = midPoints
        .slice(sIdx + 1, eIdx)
        .map((p) => ({ latitude: p.lat, longitude: p.lng }));

      // 7. Build enriched segment: snapped start → real road path → snapped end
      return [snappedStart, ...intermediatePoints, snappedEnd];
    });

    // 8. Remove all skipped segments
    return enriched.filter(Boolean);
  }

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={
        dashboardMapStyle ? dashboardMapStyles : containerStyle
      }
      center={center}
      zoom={10}
      className="dashboardMap"
      onLoad={onLoad}
      onUnmount={onUnmount}
      defaultOptions={{
        fullscreendControl: true,
        mapTypeControl: true,
        streetViewControl: true,
      }}
    >
      {isDetails &&
        hasGeofencePermission &&
        geofenceToShow &&
        Boolean(userWiseGeofences?.length > 0) &&
        userWiseGeofences?.map((item) => {
          const position = {
            lat: Number(item?.latitude),
            lng: Number(item?.longitude),
          };

          const { bgColor, textColor } = getOverlayStyles(item?.color);

          return (
            <React.Fragment key={item.id}>
              {/* Circle */}
              <Circle
                center={position}
                radius={Number(item?.radius)}
                options={{
                  strokeColor: item?.color,
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: item?.color,
                  fillOpacity: 0.35,
                }}
                onClick={() => handleOpenGeofenceSessionsModal(item)}
              />

              {/* Counter */}
              <OverlayView
                position={position}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <div
                  onClick={() => handleOpenGeofenceSessionsModal(item)}
                  style={{
                    transform: "translate(-50%, -140%)",
                    background: `linear-gradient(135deg, ${bgColor}, ${bgColor}cc)`,
                    color: textColor,
                    padding: "6px 10px",
                    borderRadius: "20px",
                    fontSize: "14px",
                    fontWeight: "700",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    boxShadow: `0 4px 12px ${bgColor}55`,
                    border: `1px solid ${bgColor}88`,
                  }}
                >
                  {`${item?.name}: ${item?.trailData?.length || 0}`}
                </div>
              </OverlayView>
            </React.Fragment>
          );
        })}

      {isDetails && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "70px",
          }}
        >
          {false && (
            <FormControl
              component="fieldset"
              style={{
                fontSize: "77px",
                fontWeight: 900,
                cursor: "default !important",
              }}
            >
              <FormControlLabel
                value="start"
                variant="body3"
                fontWeight="bold"
                sx={{ cursor: "default" }}
                control={
                  <Checkbox
                    checked={isShowLostPath}
                    // sx={{ cursor: "default" }}
                    onChange={() => setIsShowLostPath(!isShowLostPath)}
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    style={{
                      fontSize: "20px",
                      fontWeight: 900,
                      cursor: "default",
                    }}
                    color="textSecondary"
                  >
                    Show Lost Path
                  </Typography>
                }
                labelPlacement="Show Lost Path"
              />
            </FormControl>
          )}

          {isDetails && hasGeofencePermission ? (
            <FormControl
              component="fieldset"
              style={{
                fontSize: "77px",
                fontWeight: 900,
                cursor: "default !important",
              }}
            >
              <FormControlLabel
                value="start"
                variant="body3"
                fontWeight="bold"
                sx={{ cursor: "default" }}
                control={
                  <Checkbox
                    checked={geofenceToShow}
                    // sx={{ cursor: "default" }}
                    onChange={() => handleToggleGeofenceToShow()}
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    style={{
                      fontSize: "20px",
                      fontWeight: 900,
                      cursor: "default",
                    }}
                    color="textSecondary"
                  >
                    Showing Geofences
                  </Typography>
                }
                labelPlacement="Live Tracking"
              />
            </FormControl>
          ) : null}
          {isLiveTrackingOn ? (
            <FormControl
              component="fieldset"
              style={{
                fontSize: "77px",
                fontWeight: 900,
                cursor: "default !important",
              }}
            >
              <FormControlLabel
                value="start"
                variant="body3"
                fontWeight="bold"
                sx={{ cursor: "default" }}
                control={
                  <Checkbox
                    checked={true}
                    sx={{ cursor: "default" }}
                    // onChange={(e) =>
                    //   handleChangeIsLiveTrackingToShowCheckedOnCheck(
                    //     e.target.checked
                    //   )
                    // }
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    style={{
                      fontSize: "20px",
                      fontWeight: 900,
                      cursor: "default",
                    }}
                    color="textSecondary"
                  >
                    Showing Live Tracking
                  </Typography>
                }
                labelPlacement="Live Tracking"
              />
            </FormControl>
          ) : null}

          {isEnableShowActualPath && (
            <FormControl
              component="fieldset"
              style={{ fontSize: "77px", fontWeight: 900 }}
            >
              <FormControlLabel
                value="start"
                variant="body3"
                fontWeight="bold"
                control={
                  <Checkbox
                    checked={showUser}
                    onChange={(e) => handleShowUserChange(e.target.checked)}
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    style={{ fontSize: "20px", fontWeight: 900 }}
                    color="textSecondary"
                  >
                    Show User Actual Path
                  </Typography>
                }
                labelPlacement="User Show"
              />
            </FormControl>
          )}

          {/* {isPreviousPathCheckBoxToShow ? (
            <FormControl
              component="fieldset"
              style={{ fontSize: "77px", fontWeight: 900 }}
            >
              <FormControlLabel
                value="start"
                variant="body3"
                fontWeight="bold"
                control={
                  <Checkbox
                    checked={isPreviousPathToShowChecked || false}
                    onChange={(e) =>
                      handleChangeIsPreviousPathToShowCheckedOnCheck(
                        e.target.checked
                      )
                    }
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    style={{ fontSize: "20px", fontWeight: 900 }}
                    color="textSecondary"
                  >
                    Show User Previous path
                  </Typography>
                }
                labelPlacement="Previous Path"
              />
            </FormControl>
          ) : null} */}
        </div>
      )}
      {isDetails && !isLiveTrackingOn && (
        <div
          style={{
            display: "flex",
            justifyContent: "normal",
            marginRight: "70px",
          }}
        >
          <Box className="mein_UserBoxNotaion">
            <Box>
              <IconButton size="small" style={{ color: "#0085B2" }}>
                <HorizontalRuleIcon
                  style={{ fontSize: "74px", fontWeight: 900 }}
                />
              </IconButton>
              <Typography
                variant="p"
                style={{ fontSize: "20px", fontWeight: 900 }}
              >
                Path for Reimbursement
              </Typography>
            </Box>
          </Box>
        </div>
      )}

      {isDetails && isLiveTrackingOn && (
        <div
          style={{
            display: "flex",
            justifyContent: "normal",
          }}
        >
          <Box className="mein_UserBoxNotaion2">
            <Box>
              <IconButton size="small" style={{ color: "#0085B2" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    columnGap: 1,
                    minWidth: "45px",
                    marginX: "15px",
                    marginY: "25px",
                  }}
                >
                  <div
                    style={{
                      minWidth: "50%",
                      minHeight: "7px",
                      backgroundColor: "#f86a18",
                    }}
                  ></div>
                  <div
                    style={{
                      minWidth: "50%",
                      minHeight: "7px",
                      backgroundColor: "#f86a18",
                    }}
                  ></div>
                </Box>
              </IconButton>
              <Typography
                variant="p"
                style={{ fontSize: "20px", fontWeight: 900 }}
              >
                Path for Live Tracking
              </Typography>
            </Box>
            <Typography sx={{ ml: 1.5 }}>
              <Typography
                component="span"
                sx={{ fontSize: "15.5px", fontWeight: 700, mr: 1 }}
              >
                Disclaimer:
              </Typography>
              <Typography
                component="span"
                sx={{
                  fontSize: "14.5px",
                  fontWeight: 700,
                  fontStyle: "italic",
                }}
              >
                Please note that the displayed distance is an approximate
                estimate. The actual distance and route may vary slightly when
                the final route map is created.
              </Typography>
            </Typography>
          </Box>
          <Box className="mein_UserBoxNotaion2"></Box>
        </div>
      )}

      {/* Dashboard Employees */}
      {isDashboard &&
        isDashboard &&
        userInfo &&
        userInfo !== undefined &&
        userInfo.map((user, index) => {
          if (!user.latitude && !user.longitude) return;
          return (
            <UserWithLabel
              key={index}
              index={index}
              user={user}
              isEmployee={true}
            />
          );
        })}

      {/* for single employee details */}
      {/* {isDetails &&
        (details[0]?.endLatLong ? (
          <UserWithLabel
            user={{
              latitude: parseFloat(details[0]?.endLatLong.split(",")[0].trim()),
              longitude: parseFloat(
                details[0]?.endLatLong.split(",")[1].trim()
              ),
              name: details[0]?.userName,
            }}
            isEmployee={true}
          />
        ) : null)} */}

      {/* for clients */}
      {/* {isDetails &&
        details[0]?.clientCommunicationDtoList.map((client, index) => {
          return client.latLong ? (
            <UserWithLabel
              key={index}
              isClient={true}
              user={{
                latitude: parseFloat(client.latLong.split(",")[0].trim()),
                longitude: parseFloat(client.latLong.split(",")[1].trim()),
                name: client.contactPerson,
              }}
            />
          ) : null; isShowLostPath
        })} */}

      {/* for lost path details */}

      {false &&
        isShowLostPath &&
        details?.map((detail, detailIndex) => {
          const enrichedPath = insertRouteIntermediatePointsV2(
            detail?.locationGapList || [],
            detail?.routeResponse,
            { thresholdMeters: 50 },
          );
          return (
            <React.Fragment key={detailIndex}>
              {enrichedPath?.map((gap, gapIndex) => {
                if (!gap || gap.length < 2) return null;

                const start = gap[0];
                const end = gap[gap.length - 1];

                const path = gap.map((point) => ({
                  lat: Number(point.latitude),
                  lng: Number(point.longitude),
                }));

                return (
                  <React.Fragment key={gapIndex}>
                    <>
                      {/* Shadow */}
                      {/* <Polyline
                        path={path}
                        options={{
                          strokeColor: "#000000",
                          strokeOpacity: 0.25,
                          strokeWeight: 8,
                          geodesic: true,
                          zIndex: 98,
                        }}
                      /> */}

                      {/* Main polyline */}
                      <Polyline
                        path={path}
                        options={{
                          strokeColor: "#FF3B30",
                          strokeOpacity: 1,
                          strokeWeight: 2,
                          geodesic: true,
                          zIndex: 99,
                        }}
                      />
                    </>

                    {/* Start Marker */}
                    <Marker
                      position={{
                        lat: Number(start.latitude),
                        lng: Number(start.longitude),
                      }}
                    />

                    {/* End Marker */}
                    <Marker
                      position={{
                        lat: Number(end.latitude),
                        lng: Number(end.longitude),
                      }}
                    />

                    {/* Start Label */}
                    {!hiddenLabels[`start-${detailIndex}-${gapIndex}`] && (
                      <OverlayView
                        position={{
                          lat: Number(start.latitude),
                          lng: Number(start.longitude),
                        }}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                      >
                        <div
                          style={{
                            position: "relative",
                            transform: "translate(-50%, -115%)",
                            minWidth: "100px",
                            background: "#fff",
                            borderRadius: "10px",
                            padding: "10px 12px",
                            textAlign: "center",
                            boxShadow: "0 6px 20px rgba(0,0,0,.2)",
                            border: "1px solid #E5E7EB",
                            fontFamily: "Roboto",
                          }}
                        >
                          {/* Close Button */}
                          <span
                            onClick={() =>
                              setHiddenLabels((prev) => ({
                                ...prev,
                                [`start-${detailIndex}-${gapIndex}`]: true,
                              }))
                            }
                            style={{
                              position: "absolute",
                              right: 8,
                              top: 6,
                              cursor: "pointer",
                              fontSize: 16,
                              fontWeight: 700,
                              color: "#888",
                              lineHeight: 1,
                            }}
                          >
                            ✕
                          </span>

                          <div
                            style={{
                              color: "#D32F2F",
                              fontWeight: 700,
                              fontSize: 14,
                              marginBottom: 6,
                            }}
                          >
                            Lost Detect-{gapIndex + 1}
                          </div>

                          <div
                            style={{
                              fontSize: 12,
                              color: "#555",
                              fontWeight: 500,
                            }}
                          >
                            {formatDate(start.isLocationDetectedTime)}
                          </div>

                          <div
                            style={{
                              position: "absolute",
                              left: "50%",
                              bottom: "-7px",
                              width: "14px",
                              height: "14px",
                              background: "#fff",
                              borderRight: "1px solid #E5E7EB",
                              borderBottom: "1px solid #E5E7EB",
                              transform: "translateX(-50%) rotate(45deg)",
                            }}
                          />
                        </div>
                      </OverlayView>
                    )}

                    {/* End Label */}
                    {!hiddenLabels[`end-${detailIndex}-${gapIndex}`] && (
                      <OverlayView
                        position={{
                          lat: Number(end.latitude),
                          lng: Number(end.longitude),
                        }}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                      >
                        <div
                          style={{
                            position: "relative",
                            transform: "translate(-50%, -115%)",
                            minWidth: "100px",
                            background: "#fff",
                            borderRadius: "10px",
                            padding: "10px 12px",
                            textAlign: "center",
                            boxShadow: "0 6px 20px rgba(0,0,0,.2)",
                            border: "1px solid #E5E7EB",
                            fontFamily: "Roboto",
                          }}
                        >
                          {/* Close Button */}
                          <span
                            onClick={() =>
                              setHiddenLabels((prev) => ({
                                ...prev,
                                [`end-${detailIndex}-${gapIndex}`]: true,
                              }))
                            }
                            style={{
                              position: "absolute",
                              right: 8,
                              top: 6,
                              cursor: "pointer",
                              fontSize: 16,
                              fontWeight: 700,
                              color: "#888",
                              lineHeight: 1,
                            }}
                          >
                            ✕
                          </span>

                          <div
                            style={{
                              color: "#2E7D32",
                              fontWeight: 700,
                              fontSize: 14,
                              marginBottom: 6,
                            }}
                          >
                            Recover-{gapIndex + 1}
                          </div>

                          <div
                            style={{
                              fontSize: 12,
                              color: "#555",
                              fontWeight: 500,
                            }}
                          >
                            {formatDate(end.isLocationDetectedTime)}
                          </div>

                          <div
                            style={{
                              position: "absolute",
                              left: "50%",
                              bottom: "-7px",
                              width: "14px",
                              height: "14px",
                              background: "#fff",
                              borderRight: "1px solid #E5E7EB",
                              borderBottom: "1px solid #E5E7EB",
                              transform: "translateX(-50%) rotate(45deg)",
                            }}
                          />
                        </div>
                      </OverlayView>
                    )}
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          );
        })}

      {/* for route details */}

      {isDetails &&
        !isLiveTrackingOn &&
        details &&
        details.length > 0 &&
        details.map((detail, index) => {
          const polyLinePath = [];
          if (detail.routeResponse && Boolean(detail.routeResponse.length)) {
            JSON.parse(detail.routeResponse).forEach((item) => {
              item.midPointArray.forEach((val) => {
                polyLinePath.push(val);
              });
            });
          }

          console.log(polyLinePath, "polylinepath");
          return (
            <React.Fragment key={index}>
              {detail.routeResponse && Boolean(detail.routeResponse.length) ? (
                <Polyline
                  // path={JSON.parse(detail.routeResponse).midPointArray}
                  path={polyLinePath}
                  options={options}
                />
              ) : null}
            </React.Fragment>
          );
        })}

      {/* for live tracking  */}

      {isDetails &&
        isLiveTrackingOn &&
        liveTrackingPolyPath &&
        liveTrackingPolyPath.length > 0 && (
          <React.Fragment>
            <Polyline
              path={liveTrackingPolyPath}
              options={liveTrackingPolyLineOptions}
            />
          </React.Fragment>
        )}

      {/* for client details*/}
      {isDetails &&
        details &&
        details.length > 0 &&
        details.map((detail, detailIndex) => {
          // let sortDetails=detail.clientCommunicationDtoList
          const sortDetails = detail?.clientCommunicationDtoList?.map(
            (ele, index, array) => {
              return array[array.length - 1 - index];
            },
          );
          return (
            <React.Fragment key={detailIndex + 1} className="details_start">
              {sortDetails &&
                sortDetails.map((client, index) => {
                  console.log(client);
                  const currCliIndex = currCommDetl;
                  const clientInfoWindowId = `${detail.id ?? detailIndex}-${index}-${client.latLong}-${client.createdDateTime}`;
                  // if (
                  //   client.contactPerson === "Auto Default" &&
                  //   isAutoDefaultMeetingEnabled
                  // ) {
                  //   return (
                  //     <React.Fragment key={index + 3}>
                  //       {client.latLong ? (
                  //         <Marker
                  //           position={{
                  //             lat: parseFloat(
                  //               client.latLong.split(",")[0].trim()
                  //             ),
                  //             lng: parseFloat(
                  //               client.latLong.split(",")[1].trim()
                  //             ),
                  //           }}
                  //           icon={employeeIcon}
                  //           onClick={() => {
                  //             // alert("hi " + client.latLong);
                  //             // handleShowHideInfoWindow(
                  //             //   parseFloat(client.latLong.split(",")[0].trim()),
                  //             //   parseFloat(client.latLong.split(",")[1].trim()),
                  //             //   "client",
                  //             //   client,
                  //             //   currCliIndex
                  //             // );
                  //             // setShowInfoWindow(true);
                  //           }}
                  //         />
                  //       ) : null}
                  //     </React.Fragment>
                  //   );
                  // } else if (
                  //   client.contactPerson === "Auto Default" &&
                  //   !isAutoDefaultMeetingEnabled
                  // ) {
                  //   return null;
                  // }
                  return (
                    <React.Fragment key={index + 3}>
                      {client.latLong ? (
                        <Marker
                          position={{
                            lat: parseFloat(
                              client.latLong.split(",")[0].trim(),
                            ),
                            lng: parseFloat(
                              client.latLong.split(",")[1].trim(),
                            ),
                          }}
                          onClick={() => {
                            // alert("hi " + client.latLong);
                            // handleShowHideInfoWindow(
                            //   parseFloat(client.latLong.split(",")[0].trim()),
                            //   parseFloat(client.latLong.split(",")[1].trim()),
                            //   "client",
                            //   client,
                            //   currCliIndex
                            // );
                            setClosedClientInfoWindows((closedWindows) => ({
                              ...closedWindows,
                              [clientInfoWindowId]: false,
                            }));
                          }}
                        />
                      ) : null}

                      {!closedClientInfoWindows[clientInfoWindowId] &&
                      client.latLong ? (
                        <InfoWindow
                          onCloseClick={() =>
                            setClosedClientInfoWindows((closedWindows) => ({
                              ...closedWindows,
                              [clientInfoWindowId]: true,
                            }))
                          }
                          onLoad={onLoadInfo}
                          position={{
                            lat: parseFloat(
                              client.latLong.split(",")[0].trim(),
                            ),
                            lng: parseFloat(
                              client.latLong.split(",")[1].trim(),
                            ),
                          }}
                        >
                          <div
                            className={`infhobox ${
                              client?.meetingSubmitedFromOtherLocation
                                ? "map-info-card--warning"
                                : ""
                            }`}
                            style={{
                              ...divStyleClient,
                              ...(client?.meetingSubmitedFromOtherLocation
                                ? {
                                    background:
                                      "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
                                    color: "#8a4b00",
                                    boxShadow:
                                      "0 10px 24px rgba(255, 140, 0, 0.18)",
                                  }
                                : {}),
                            }}
                          >
                            <div className="map-info-card__content">
                              <div className="map-info-card__badge">
                                Client visit
                              </div>
                              <div className="map-info-card__title">{`${
                                client.contactPerson
                              } (${currCommDetl++})`}</div>
                              <div className="map-info-card__time">
                                {moment(client.createdDateTime).format(
                                  "hh:mm: A",
                                )}
                              </div>
                            </div>
                            <button
                              type="button"
                              className="map-info-card__close"
                              onClick={() =>
                                setClosedClientInfoWindows((closedWindows) => ({
                                  ...closedWindows,
                                  [clientInfoWindowId]: true,
                                }))
                              }
                              aria-label="Close information"
                            >
                              <CloseIcon sx={{ fontSize: 14 }} />
                            </button>
                          </div>
                        </InfoWindow>
                      ) : null}
                    </React.Fragment>
                  );
                })}
            </React.Fragment>
          );
        })}

      {showUser === true &&
        isDetails &&
        details &&
        details.map((data, ind) => {
          console.log(data, "wgdyefyeey");
          const DefaultUserIcon = {
            url: locationIcon,
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(15, 15),
            scaledSize: new window.google.maps.Size(30, 30),
          };
          //var markerLabel = 'GO!';

          return (
            <>
              {data &&
                data.usersOdLocationTrackHistoryDtoList &&
                data.usersOdLocationTrackHistoryDtoList.map((val, index) => {
                  return (
                    <>
                      <Marker
                        icon={DefaultUserIcon}
                        position={{
                          lat: val.latitude,
                          lng: val.longitude,
                        }}
                        onClick={() => openStopLocation(`${ind}-${index}`)}
                      >
                        {stopLocationInfho === true &&
                        !closedStopLocationWindows[`${ind}-${index}`] ? (
                          <InfoWindow
                            onCloseClick={() =>
                              CloseStopLocation(`${ind}-${index}`)
                            }
                            onLoad={onLoadInfo}
                            position={{
                              lat: val.latitude,
                              lng: val.longitude,
                            }}
                          >
                            <div className="infhobox" style={divStyleClient}>
                              <div className="map-info-card__content">
                                <div className="map-info-card__badge">
                                  Location point
                                </div>
                                <div className="map-info-card__title">
                                  {`${index + 1}`}
                                </div>
                                <div className="map-info-card__time">
                                  {val && val.createdDate
                                    ? moment(val.createdDate).format("hh:mm: A")
                                    : "NA"}
                                </div>
                              </div>
                              <button
                                type="button"
                                className="map-info-card__close"
                                onClick={() =>
                                  CloseStopLocation(`${ind}-${index}`)
                                }
                                aria-label="Close information"
                              >
                                <CloseIcon sx={{ fontSize: 14 }} />
                              </button>
                            </div>
                          </InfoWindow>
                        ) : null}
                      </Marker>
                    </>
                  );
                })}
            </>
          );
        })}

      {/* {paths && paths.map((val, index) => {
        const DefaultUserIcon = {
          url: locationIcon,
           origin: new window.google.maps.Point(0, 0),
          // anchor: new window.google.maps.Point(15, 15),
          scaledSize: new window.google.maps.Size(50, 50)
        };
        
        return (
          <>
            <Marker icon={DefaultUserIcon} position={{
              lat: val.lat, lng: val.lng
            }}
              onClick={() => openStopLocation(index)}
            >
              {stopLocationInfho === true  ? (
                <InfoWindow
                  onCloseClick={() => CloseStopLocation()}
                  onLoad={onLoadInfo}
                  position={{
                    lat: val.lat, lng: val.lng
                  }}
                >
                  <div>
                    <div>
                      <h4 style={{position:"relative",right:"45px"}}> {`${index + 1}`}
                      </h4>
                      <h5>{moment().format("hh:mm: A")}</h5>
                    </div>
                    <div>
                      <p className="closeBtninfhowindow">
                        <CloseIcon
                          onClick={() => CloseStopLocation()}
                          sx={{ width: "13px" }}
                        />
                      </p>
                    </div>
                  </div>
                </InfoWindow>
              ) : null}
            </Marker>
          </>
        )
      })} */}

      {/* {isDetails &&
        (details[0]?.startLatLong ? (
          <UserWithLabel
            user={{
              latitude: parseFloat(
                details[0]?.endLatLong?.split(",")[0].trim()
              ),
              longitude: parseFloat(
                details[0]?.endLatLong?.split(",")[1].trim()
              ),
              name: details[0]?.userName,
            }}
            isEmployee={true}
          />
        ) : null)} */}

      {/* start point InfoWindow */}

      {isDetails &&
        (Boolean(details?.length) ? (
          <React.Fragment>
            {Array.from(uniqueDetailsStartPoints)?.map((point, index) => {
              const [parsedLat, parsedLng, parsedCreatedDate] = point
                .split(",")
                .map((cord) => parseFloat(cord.trim()));

              console.log("tension: ", parsedLat, parsedLng, parsedCreatedDate);

              if (
                !isNaN(parsedLat) &&
                !isNaN(parsedLng) &&
                !isNaN(parsedCreatedDate)
              ) {
                return (
                  <React.Fragment key={index}>
                    <Marker
                      onClick={() => setShowInfoWindow(true)}
                      position={{
                        lat: parsedLat,
                        lng: parsedLng,
                      }}
                    />
                    {showInfoWindow && (
                      <InfoWindow
                        className="details_start"
                        onCloseClick={() => setShowInfoWindow(false)}
                        onLoad={onLoadInfo}
                        position={{
                          lat: parsedLat,
                          lng: parsedLng,
                        }}
                      >
                        {/* <div style={divStyleStart} className="ok">
                  <h4
                    style={{
                      marginBottom: "0rem",
                    }}
                  >
                    Start
                  </h4>
                  <h4>{moment(details[0]?.createdDate).format("hh:mm: A")}</h4>
                </div> */}
                        <div className="infhobox" style={divStyleStart}>
                          <div className="map-info-card__content">
                            <div className="map-info-card__badge">
                              Trip start
                            </div>
                            <div className="map-info-card__title">Start</div>
                            <div className="map-info-card__time">
                              {moment(parsedCreatedDate).format("hh:mm: A")}
                            </div>
                          </div>
                          <button
                            type="button"
                            className="map-info-card__close"
                            onClick={() => setShowInfoWindow(false)}
                            aria-label="Close information"
                          >
                            <CloseIcon sx={{ fontSize: 14 }} />
                          </button>
                        </div>
                      </InfoWindow>
                    )}
                  </React.Fragment>
                );
              }
              return null;
            })}

            {/* 
                     <Marker
              onClick={() => setShowInfoWindow(true)}
              position={{
                lat: parseFloat(
                  details && details[0].startLatLong.split(",")[0].trim()
                ),
                lng: parseFloat(
                  details && details[0].startLatLong.split(",")[1].trim()
                ),
              }}
            />
            {showInfoWindow && (
              <InfoWindow
                className="details_start"
                onCloseClick={() => setShowInfoWindow(false)}
                onLoad={onLoadInfo}
                position={{
                  lat: parseFloat(
                    details && details[0].startLatLong.split(",")[0].trim()
                  ),
                  lng: parseFloat(
                    details && details[0].startLatLong.split(",")[1].trim()
                  ),
                }}
              >
               
                <div className="infhobox" style={divStyleStart}>
                  <div>
                    <h4
                      style={{
                        marginBottom: "0rem",
                      }}
                    >
                      Start
                    </h4>
                    <h4>
                      {moment(details && details[0]?.createdDate).format(
                        "hh:mm: A"
                      )}
                    </h4>
                  </div>
                  <div>
                    <p className="closeBtninfhowindow">
                      <CloseIcon
                        onClick={() => setShowInfoWindow(false)}
                        sx={{ width: "13px" }}
                      />
                    </p>
                  </div>
                </div>
              </InfoWindow>
            )} */}
          </React.Fragment>
        ) : null)}

      {/* end point InfoWindow */}

      {isDetails &&
        (Boolean(details?.length) ? (
          <React.Fragment>
            {Array.from(uniqueDetailsEndPoints)?.map((endPoint, index) => {
              const [parsedLat, parsedLng, parsedDate] = endPoint
                .split(",")
                .map((cord) => parseFloat(cord.trim()));

              console.log("tension2: ", parsedLat, parsedLng, parsedDate);

              if (
                !isNaN(parsedLat) &&
                !isNaN(parsedLng) &&
                !isNaN(parsedDate)
              ) {
                return (
                  <React.Fragment key={index}>
                    <Marker
                      onClick={() => setShowInfoWindow(true)}
                      position={{
                        lat: parsedLat,
                        lng: parsedLng,
                      }}
                    />
                    {showInfoWindow && !isLiveTrackingOn && (
                      <InfoWindow
                        onCloseClick={() => setShowInfoWindow(false)}
                        onLoad={onLoadInfo}
                        position={{
                          lat: parsedLat,
                          lng: parsedLng,
                        }}
                      >
                        {/* <div style={divStyleEnd}>
                                <h3
                                  style={{
                                    marginBottom: "0rem",
                                  }}
                                >
                                  End
                                </h3>
                                <h4>{moment(details[0]?.date).format("hh:mm: A")}</h4>
                              </div> */}
                        <div className="infhobox" style={divStyleEnd}>
                          <div className="map-info-card__content">
                            <div className="map-info-card__badge">Trip end</div>
                            <div className="map-info-card__title">End</div>
                            <div className="map-info-card__time">
                              {moment(parsedDate).format("hh:mm: A")}
                            </div>
                          </div>
                          <button
                            type="button"
                            className="map-info-card__close"
                            onClick={() => setShowInfoWindow(false)}
                            aria-label="Close information"
                          >
                            <CloseIcon sx={{ fontSize: 14 }} />
                          </button>
                        </div>
                      </InfoWindow>
                    )}
                  </React.Fragment>
                );
              }
              return null;
            })}
            {/* <Marker
              onClick={() => setShowInfoWindow(true)}
              position={{
                lat: parseFloat(
                  details && details[0].endLatLong.split(",")[0].trim()
                ),
                lng: parseFloat(
                  details && details[0].endLatLong.split(",")[1].trim()
                ),
              }}
            />
            {showInfoWindow && (
              <InfoWindow
                onCloseClick={() => setShowInfoWindow(false)}
                onLoad={onLoadInfo}
                position={{
                  lat: parseFloat(
                    details && details[0].endLatLong.split(",")[0].trim()
                  ),
                  lng: parseFloat(
                    details && details[0].endLatLong.split(",")[1].trim()
                  ),
                }}
              >
         
                <div className="infhobox" style={divStyleEnd}>
                  <div>
                    <h3
                      style={{
                        marginBottom: "0rem",
                      }}
                    >
                      End
                    </h3>
                    <h4>
                      {moment(details && details[0]?.date).format("hh:mm: A")}
                    </h4>
                  </div>
                  <div>
                    <p className="closeBtninfhowindow">
                      <CloseIcon
                        onClick={() => setShowInfoWindow(false)}
                        sx={{ width: "13px" }}
                      />
                    </p>
                  </div>
                </div>
              </InfoWindow>
            )} */}
          </React.Fragment>
        ) : null)}

      {/* for addtional infowindow object */}

      {/* {showHideInfoWindowLatLong &&
        showHideInfoWindowLatLong.type === "client" && (
          <InfoWindow
            onLoad={onLoadInfo}
            position={{
              lat: parseFloat(showHideInfoWindowLatLong.lat),
              lng: parseFloat(showHideInfoWindowLatLong.lng),
            }}
          >
            <div style={divStyleClient}>
              <h4>{`${showHideInfoWindowLatLong.client.contactPerson} (${showHideInfoWindowLatLong.currCliIndex})`}</h4>
              <h5>{showHideInfoWindowLatLong.client.createTime}</h5>
            </div>
          </InfoWindow>
        )} */}
    </GoogleMap>
  ) : (
    <></>
  );
};

export default MapComponent;
